export * from './nav-dropdown.directive';



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/directives/nav-dropdown/index.ts